import { initialEfakturaSharingState } from './state';
const reducer = (state, action) => {
    switch (action.type) {
        case 'ssn': {
            return {
                ...state,
                ssn: action.payload,
            };
        }
        case 'name':
            return {
                ...state,
                name: action.payload,
            };
        case 'amountSelected':
            return {
                ...state,
                amountSelected: action.payload,
            };
        case 'selected':
            return {
                ...state,
                selected: action.payload,
            };
        case 'reset':
            return {
                ...initialEfakturaSharingState,
            };
        default:
            return state;
    }
};
const efakturaSharingReducer = (state, action) => {
    const newState = reducer(state, action);
    if (process.env.NODE_ENV === 'development') {
        // eslint-disable-next-line no-console
        console.log('%cEfaktura sharing form', 'color: green; font-weight: bold', action, 'new state', newState);
    }
    return newState;
};
export default efakturaSharingReducer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVkdWNlci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy93aWRnZXRzL0VmYWt0dXJhU2hhcmluZy9mb3JtL3JlZHVjZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0EsT0FBNkIsRUFBRSwyQkFBMkIsRUFBRSxNQUFNLFNBQVMsQ0FBQztBQUU1RSxNQUFNLE9BQU8sR0FBRyxDQUFDLEtBQTJCLEVBQUUsTUFBNkIsRUFBd0IsRUFBRTtJQUNqRyxRQUFRLE1BQU0sQ0FBQyxJQUFJLEVBQUUsQ0FBQztRQUNsQixLQUFLLEtBQUssQ0FBQyxDQUFDLENBQUM7WUFDVCxPQUFPO2dCQUNILEdBQUcsS0FBSztnQkFDUixHQUFHLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDdEIsQ0FBQztRQUNOLENBQUM7UUFDRCxLQUFLLE1BQU07WUFDUCxPQUFPO2dCQUNILEdBQUcsS0FBSztnQkFDUixJQUFJLEVBQUUsTUFBTSxDQUFDLE9BQU87YUFDdkIsQ0FBQztRQUNOLEtBQUssZ0JBQWdCO1lBQ2pCLE9BQU87Z0JBQ0gsR0FBRyxLQUFLO2dCQUNSLGNBQWMsRUFBRSxNQUFNLENBQUMsT0FBTzthQUNqQyxDQUFDO1FBQ04sS0FBSyxVQUFVO1lBQ1gsT0FBTztnQkFDSCxHQUFHLEtBQUs7Z0JBQ1IsUUFBUSxFQUFFLE1BQU0sQ0FBQyxPQUFPO2FBQzNCLENBQUM7UUFDTixLQUFLLE9BQU87WUFDUixPQUFPO2dCQUNILEdBQUcsMkJBQTJCO2FBQ2pDLENBQUM7UUFDTjtZQUNJLE9BQU8sS0FBSyxDQUFDO0lBQ3JCLENBQUM7QUFDTCxDQUFDLENBQUM7QUFFRixNQUFNLHNCQUFzQixHQUFHLENBQUMsS0FBMkIsRUFBRSxNQUE2QixFQUF3QixFQUFFO0lBQ2hILE1BQU0sUUFBUSxHQUFHLE9BQU8sQ0FBQyxLQUFLLEVBQUUsTUFBTSxDQUFDLENBQUM7SUFDeEMsSUFBSSxPQUFPLENBQUMsR0FBRyxDQUFDLFFBQVEsS0FBSyxhQUFhLEVBQUUsQ0FBQztRQUN6QyxzQ0FBc0M7UUFDdEMsT0FBTyxDQUFDLEdBQUcsQ0FBQyx5QkFBeUIsRUFBRSxpQ0FBaUMsRUFBRSxNQUFNLEVBQUUsV0FBVyxFQUFFLFFBQVEsQ0FBQyxDQUFDO0lBQzdHLENBQUM7SUFDRCxPQUFPLFFBQVEsQ0FBQztBQUNwQixDQUFDLENBQUM7QUFFRixlQUFlLHNCQUFzQixDQUFDIn0=